export const logIt = (...data: any) => {
  console.log(':>', ...data);
};

export const logError = (...data: any) => {
  console.error('<<App Error>>', ...data);
};
